import axios from "axios";
import {threeDConverterServicesPath, utilityServicesPath} from "../../Constants";
import FileService from "../orders/orders/customer/FileService";

const fileRestThreeDConverter = utilityServicesPath

export default class ThreeDConverterService {

    static async getAllByOrderId(orderId) {
        return axios.get(fileRestThreeDConverter + "/customers/three-d-imports/orders/" + orderId) ;
    }
    static async getMessagesById(import3DId) {
        return axios.get(fileRestThreeDConverter + "/customers/three-d-imports/messages/orders/" + import3DId) ;
    }

    static async uploadB3d(file, checkModel, orderId) {
        const query = `&checkModel=${checkModel}`
        return await axios.post(fileRestThreeDConverter + "/customers/files/upload-3d-model" + "?orderId="
            + orderId + query,
            FileService.getFormDataArray(file, "file"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }
}